<template>
  <div ref="menu" class="menu-wrapper">
    <div :ref="refButtonContainer" :class="classButtonContainer" @click="triggerClick">
      <slot v-if="$slots['menu-button']" name="menu-button" :toggle-menu="e => toggleMenu(e)"></slot>
      <button
        v-else
        ref="button"
        class="menu-wrapper-button"
        :aria-expanded="isOpen.toString()"
        aria-haspopup="true"
        :aria-controls="id"
        @click="toggleMenu"
      >
        <slot name="menu-button-text" />
      </button>
    </div>
    <teleport to="body">
      <template v-if="renderDemand">
        <ul
          v-if="isOpen"
          :id="id"
          ref="list"
          class="menu-wrapper-menu"
          :class="classRoot"
          role="menu"
          :style="{
            left: left,
            right: right,
            top: top,
            bottom: bottom,
            maxHeight: maxHeight + 'px',
            overflow: 'auto',
          }"
          @close_menu="closeHandler()"
        >
          <slot name="menu-content" :close-handler="closeHandler" />
        </ul>
      </template>
      <template v-else>
        <ul
          v-show="isOpen"
          :id="id"
          ref="list"
          class="menu-wrapper-menu"
          :class="classRoot"
          role="menu"
          :style="{
            left: left,
            right: right,
            top: top,
            bottom: bottom,
            maxHeight: maxHeight + 'px',
            overflow: 'auto',
          }"
          @close_menu="closeHandler()"
        >
          <slot name="menu-content" :close-handler="closeHandler" />
        </ul>
      </template>
    </teleport>
  </div>
</template>

<script>
import componentUtil from '@/commons/componentUtil';

export default {
  props: {
    minWidth: {
      default: null,
      type: [Number, String],
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    hideInContent: {
      default: true,
      type: Boolean,
    },
    maxHeight: {
      default: null,
      type: [Number, String],
    },
    classRoot: {
      default: '',
      type: String,
    },
    position: {
      default: null,
      type: Object,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    /** Căn trái */
    isLeft: {
      default: true,
      type: Boolean,
    },
    refButtonContainer: {
      default: 'buttonContainer',
      type: String,
    },
    classButtonContainer: {
      default: 'menu-button-container',
      type: String,
    },
    //Prop xác định xem có căn lề trái của menu-wrapper-menu theo button quickadd không
    //VDDONG 18/07/2023
    leftByButtonQuickAdd: {
      type: Boolean,
      default: false,
    },
    renderDemand: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {
      isOpen: false,
      id: null,
      left: 'unset',
      right: 'unset',
      top: 0,
      bottom: 'unset',
    };
  },
  watch: {
    isOpen(newVal, oldVal) {
      if (newVal) {
        // xử lý Nếu không phải Menu thêm nhanh nhiều object trong combobox
        if (!(this.$attrs['class'] && this.$attrs['class'].includes('menu-wrapper-quick-add-multi'))) {
          /** Thực hiện gán sự kiện click outside */
          if (this.isGridEditor) {
            // Nếu thuộc grid thì thực hiện action Click. fake-click: là class nằm ngoài của formpopup
            // việc trigger vào đây sẽ giúp cho control trên grid ko bị dispose
            document.querySelector('.fake-click').click();
          } else {
            if (document.querySelector('.fake-click-popup')) {
              // Không phải grid thì trigger vào đây. fake-click-popup: là class con của formID.
              // Mỗi popup có grid chứa combo có quickAddMulti thì cần có formID là root của form popup đó
              // trigger vào đây thì grideditor sẽ chạy onClickAway và dispose control đi
              document.querySelector('.fake-click-popup').click();
            } else if (this.refButtonContainer === 'buttonContainer') {
              // MenuWrapper này nằm ngoài danh sách, ko có formID thì sẽ chạy vào đây
              document.querySelector('body').click();
            }
          }
        }
        setTimeout(() => {
          document.addEventListener('keydown', this.documentKeydown);
          document.addEventListener('click', this.documentClick);
        }, 0);

        this.top = '0px';
        this.left = '0px';
        this.$nextTick(() => {
          let position = {};
          if (this.position && this.position.top && this.position.left) {
            position = this.position;
          } else {
            position = componentUtil.getPosition(
              this.$refs[this.refButtonContainer],
              this.$refs['list'],
              this.position,
            );
          }

          this.top = position.top + 'px';
          // this.left = position.left + 'px';
          //VDDONG 18/07/2023: Nếu có căn lề trái menu wrapper quick add theo button quickadd
          if (this.leftByButtonQuickAdd) {
            let widthMenuWrapper = document.querySelector('.menu-wrapper-menu')?.offsetWidth ?? 0; //độ rộng menu-wrapper-menu
            let widthButtonQuickAdd = document.querySelector('.menu-button-container .quickAdd')?.offsetWidth ?? 0; //độ rộng button quick add
            this.left = this.isLeft ? position.left + widthMenuWrapper - widthButtonQuickAdd + 'px' : 'unset';
          } else {
            this.left = this.isLeft ? position.left + 'px' : 'unset';
          }
          this.right = this.isLeft ? 'unset' : position.right + 'px';
        });
      } else {
        this.$emit('closeMenuWrapper');
        document.removeEventListener('keydown', this.documentKeydown);
        document.removeEventListener('click', this.documentClick);
      }
    },
  },
  mounted() {
    this.id = Math.random().toString(36).substring(2, 15);
  },
  unmounted() {
    document.removeEventListener('keydown', this.documentKeydown);
    document.removeEventListener('click', this.documentClick);
  },
  beforeUnmount() {
    const el = this.$refs.list;
    el && el.remove();
  },
  methods: {
    documentKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeHandler();
      }
    },
    isDispose(target) {
      const el = this.$refs.list;
      /** Các container sẽ ko dispose cell */
      const classes = [
        '.calendar-container.datepicker',
        '.combo-dropdown-panel',
        '.msg-box-context-menu',
        '.icon16.ic-multiply',
      ]; // thêm container ko bị dispose
      const dispose =
        classes.findIndex(className => {
          return target.closest && (target.closest(className) || target.className.contains(className));
        }) === -1;

      if (dispose && el !== target && !el.contains(target)) {
        return true;
      }
    },
    documentClick(e) {
      const el = this.$refs.list;
      const target = e.target;
      const isSubgroup = !!target.closest('.menu-group-item');
      // Check thêm trường hợp click vào form thông báo
      // VDDONG 26/04/2023
      const isNotifyContainer = !!target.closest('.notification-container');
      if (!isSubgroup && !isNotifyContainer) {
        if (this.hideInContent) {
          this.closeHandler();
          return;
        }

        if (this.isDispose(target)) {
          this.closeHandler();
        }
      }
    },
    toggleMenu(e) {
      e.stopPropagation();

      if (!this.disabled) {
        this.$emit('click', !this.isOpen);
        this.isOpen = !this.isOpen;

        // Add class đánh dấu active
        if (this.isOpen) {
          this.$el.classList.add('active');
        } else {
          this.$el.classList.remove('active');
        }
      }
    },
    closeHandler() {
      this.isOpen = false;

      // remove
      this.$el.classList.remove('active');
    },
    /**
     * Hàm thực thi click khi chỉ có 1 button trong buttonContainer
     */
    triggerClick() {
      const buttons = this.$refs.buttonContainer.querySelectorAll('button');
      if (buttons.length == 1) {
        buttons[0].click();
      }
    },
  },
};
</script>

<style lang="scss">
.menu-wrapper-button {
  background-color: transparent;
  border: 1px solid #555;
  cursor: pointer;
  font-size: inherit;
  display: inline-block;
  border-radius: 3px;
  font-weight: $font-weight-bold;
  line-height: 20px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  margin: 0 0 0 4px;
}

.menu-wrapper-button:focus {
  outline: 0;
  color: #236ca4;
  border-color: #236ca4;
  box-shadow: 0 0 3px 2px #236ca4;
}

.menu-wrapper-menu {
  list-style: none;
  margin: 0;
  padding-left: 0;
  margin: 4px;
  animation: slide-down 0s ease;
  position: absolute;
  z-index: 9999;
  background-color: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  min-width: 136px;
  /** Style scrollbar trên FireFox**/
  scrollbar-color: #b8bcc3 transparent;
  scrollbar-width: thin;
  /** Style scrollbar trên FireFox**/
}

.menu-wrapper-menu.quick-add-grid {
  z-index: 100000;
}
.filter-menu-item {
  .label {
    color: $black;
  }
}

.menu-wrapper-item {
  outline: none;
  color: inherit;
  text-decoration: none;
  line-height: 33px;
  height: 33px;
  padding: 0 16px;
  cursor: pointer;
  display: block;
  transition: all 0s ease;
  white-space: nowrap;
  width: 100%;
  &.focus{
    background-color: $menu-wapper-hv;
    border-radius: 2px;
    color: $primary;
    text-shadow: 0px 0px 1px $primary;
  }
}

.menu-wrapper-item:hover {
  outline: 0;
  background-color: $menu-wapper-hv;
  border-radius: 2px;
  color: $primary;
  text-shadow: 0px 0px 1px $primary;
  transition: all 0s ease;
  .menu-item-ic {
    &.ic-filter- {
      &contain:before {
        background-position: -432px -240px;
      }
      &equal:before {
        background-position: -359px -288px;
      }
      &not-equal:before {
        background-position: -335px -288px;
      }
      &not-contain:before {
        background-position: -311px -336px;
      }
      &greater-than:before {
        background-position: -263px -288px;
      }
      &greater-than-or-eq:before {
        background-position: -312px -288px;
      }
      &less-than:before {
        background-position: -240px -288px;
      }
      &less-than-or-eq:before {
        background-position: -289px -288px;
      }
      &start-with:before {
        background-position: -431px -288px;
      }
      &ends-with:before {
        background-position: -457px -288px;
      }
      &null:before {
        background-position: -384px -288px;
      }
      &not-null:before {
        background-position: -408px -288px;
      }
      &remove:before {
        background-position: -192px -288px;
      }
    }
  }
}

@keyframes slide-down {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

//thực hiện đóng thực hiện hàng loạt và lọc
// .menu-button-container:has(.circle-button) {
//   pointer-events: none;
// }
</style>
